import { combineReducers } from 'redux'
import { authReducer } from './auth.reducer'
import { billReducer } from './bill.reducer';
import { clientReducer } from './client.reducer';
import { clientPaymentAccountReducer } from "./clientPaymentAccount.reducer";
import { configReducer } from './config.reducer';
import { consumerReducer } from './consumer.reducer';
import { notificationReducer } from './notification.reducer';
import { paymentTransactionReducer } from './paymentTransaction.reducer';
import { roleReducer } from './role.reducer';
import { userReducer } from './user.reducer';
import orgReducer from './clients'
import { collectionMethodReducer } from './collectionMethod.reducer';
import { gatewayMerchantAccountReducer } from './gatewayMerchantAccount.reducer';
import { clientGatewayAccountReducer } from './clientGatewayAccount.reducer';
import { billerNetworkAccountReducer } from './billerNetworkAccount.reducer';

export default combineReducers({
    auth: authReducer,
    roles: roleReducer,
    users: userReducer,
    clients: clientReducer,
    clientPaymentAccounts: clientPaymentAccountReducer,
    consumers: consumerReducer,
    bills: billReducer,
    notifications: notificationReducer,
    paymentTransactions: paymentTransactionReducer,
    config: configReducer,
    org: orgReducer,
    collectionMethods: collectionMethodReducer,
    gatewayMerchantAccounts: gatewayMerchantAccountReducer,
    clientGatewayAccounts: clientGatewayAccountReducer,
    billerNetworkAccounts: billerNetworkAccountReducer,
});
